/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import classnames from 'classnames';
import './LinkedAdjustmentLinkIcon.scss';

export const LinkedAdjustmentLinkIcon = ({
  interactive,
  isSelected,
  isBroken,
  isVisible,
  handleKeyDown,
}) => {
  const onKeyDown = (e) => {
    if (handleKeyDown) {
      handleKeyDown(e);
    }
  };
  return (
    <div
      className="linked-adjustment-icon-container"
      tabIndex="0"
      onKeyDown={onKeyDown}
    >
      <Icon
        name={isBroken ? 'link-remove' : 'link'}
        width="18px"
        className={classnames('linked-adjustment-icon', {
          'icon-gray': !isVisible && !interactive,
          'icon-orange': interactive && !isBroken,
          'icon-red': interactive && isBroken,
          'icon-gray-theme': isVisible,
          fill: isVisible,
          outline: !isSelected || !isVisible,
          interactive,
        })}
      />
    </div>
  );
};

LinkedAdjustmentLinkIcon.propTypes = {
  interactive: PropTypes.bool,
  isSelected: PropTypes.bool,
  isBroken: PropTypes.bool,
};

LinkedAdjustmentLinkIcon.defaultProps = {
  interactive: true,
  isSelected: false,
  isBroken: false,
};
